import httpClient from "../config/httpClient";
import { ProductTransitionGroupAggrupationsMapDto } from "../models/product-transition-group/productTransitionGroupMap.model";

export class ProductsDependenciesService {
	private static readonly URL_PRODUCTS_DEPENDENCIES = "/admin/product-transition-groups";
	private static readonly URL_PRODUCTS_DEPENDENCIES_COMBINATIONS = "/admin/product-transition-groups/combinations";

	public static getProductTransitionGroups(params?: { page?: number; limit?: number; search?: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}`;
		return httpClient.get(url, { params });
	}

	public static createProductTransitionGroup(data: any) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}`;
		return httpClient.post(url, data);
	}

	public static patchProductTransitionGroup(id: number, data: any) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/${id}`;
		return httpClient.patch(url, data);
	}

	public static getDropdownsByCustomerTypeField({ customerType, field }: { customerType: string; field: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/dropdowns`;
		return httpClient.get(url, { params: { customerType, field } });
	}

	public static getBundleConfigurations(aggrupationId: number) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations/${aggrupationId}/compatible-bundle-type-configurations/options`;
		return httpClient.get(url);
	}

	public static getCombinationDropdowns({ groupId, field }: { groupId: number; field: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/${groupId}/combinations/dropdowns`;
		return httpClient.get(url, { params: { field } });
	}

	public static createCombination(data: any) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES_COMBINATIONS}`;
		return httpClient.post(url, data);
	}

	public static patchCombination(id: number, data: any) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES_COMBINATIONS}/${id}`;
		return httpClient.patch(url, data);
	}

	public static getListAggrupations(params?: { page?: number; limit?: number; search?: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations`;
		return httpClient.get(url, { params });
	}

	public static getAggrupations() {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations`;
		return httpClient.get(url);
	}

	public static createAggrupation(data: { name: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations`;
		return httpClient.post(url, data);
	}

	public static patchAggrupation(aggrupationId: number, data: { name: string }) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations/${aggrupationId}`;
		return httpClient.patch(url, data);
	}

	public static deleteAggrupation(aggrupationId: number) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/aggrupations/${aggrupationId}`;
		return httpClient.delete(url);
	}

	public static getProductTransitionGroupOptions(groupId: number) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/${groupId}/options`;
		return httpClient.get(url);
	}

	public static checkProductTransitionGroupOptions(
		groupId: number,
		data: {
			fiber?: { bandwidth?: string };
			voip?: { qty?: number };
			mobile?: { data?: number };
		}
	) {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/${groupId}/options/check`;
		return httpClient.put(url, data);
	}

	public static getConceptMap() {
		const url = `${this.URL_PRODUCTS_DEPENDENCIES}/map`;
		return httpClient.get<ProductTransitionGroupAggrupationsMapDto>(url).then((response) => response.data);
	}
}
